/** Valores por defecto de negocio (ajustar solo aquí si la marca cambia los textos). */
export const UTM_DEFAULT_SOURCE = "organico";
export const UTM_DEFAULT_MEDIUM = "landing_mkt";
export const UTM_DEFAULT_CAMPAIGN = "hyundai";

function getSearchParams() {
  if (typeof window === "undefined") return new URLSearchParams();
  return new URLSearchParams(window.location.search);
}

function storageGet(key) {
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
}

function normalizeParam(value) {
  if (value == null) return null;
  const s = String(value).trim();
  return s || null;
}

export function sanitizeMarketingUtmSource(value) {
  const n = normalizeParam(value);
  if (!n) return null;
  const compact = n.replace(/\s+/g, " ").replace(/_/g, " ").trim();
  if (/^consulta web$/i.test(compact)) return null;
  if (compact.toLowerCase() === "directo") return null;
  return n;
}

function resolveUtmSource(value) {
  return sanitizeMarketingUtmSource(value) || UTM_DEFAULT_SOURCE;
}

/** True si en la query actual no hay utm_source, utm_medium ni utm_campaign (tras trim). */
export function urlSinUtmsPrincipales(query = getSearchParams()) {
  const s = sanitizeMarketingUtmSource(query.get("utm_source"));
  const m = query.get("utm_medium")?.trim();
  const c = query.get("utm_campaign")?.trim();
  return !s && !m && !c;
}

export function getUtmParams() {
  const query = getSearchParams();

  if (urlSinUtmsPrincipales(query)) {
    return {
      utm_source: UTM_DEFAULT_SOURCE,
      utm_medium: UTM_DEFAULT_MEDIUM,
      utm_campaign: UTM_DEFAULT_CAMPAIGN,
    };
  }

  const pick = (key, def) => {
    const fromUrl = query.get(key)?.trim();
    if (fromUrl) return fromUrl;
    const fromSt = storageGet(key)?.trim();
    if (fromSt) return fromSt;
    return def;
  };

  const utm_source = resolveUtmSource(pick("utm_source", UTM_DEFAULT_SOURCE));
  const utm_medium = pick("utm_medium", UTM_DEFAULT_MEDIUM) || UTM_DEFAULT_MEDIUM;
  const utm_campaign = pick("utm_campaign", UTM_DEFAULT_CAMPAIGN) || UTM_DEFAULT_CAMPAIGN;

  const utUrl = query.get("utm_term")?.trim();
  const utSt = storageGet("utm_term")?.trim();
  const utm_term = utUrl || utSt || undefined;

  const out = { utm_source, utm_medium, utm_campaign };
  if (utm_term) out.utm_term = utm_term;
  return out;
}

export function saveUtmParams() {
  if (typeof window === "undefined") return;
  const query = getSearchParams();

  if (urlSinUtmsPrincipales(query)) {
    sessionStorage.setItem("utm_source", UTM_DEFAULT_SOURCE);
    sessionStorage.setItem("utm_medium", UTM_DEFAULT_MEDIUM);
    sessionStorage.setItem("utm_campaign", UTM_DEFAULT_CAMPAIGN);
    sessionStorage.removeItem("utm_term");
    return;
  }

  ["utm_source", "utm_medium", "utm_campaign", "utm_term"].forEach((key) => {
    const v = query.get(key);
    if (v != null && String(v).trim() !== "") {
      if (key === "utm_source") {
        sessionStorage.setItem(key, resolveUtmSource(v));
      } else {
        sessionStorage.setItem(key, v);
      }
    }
  });
}

export function getCurrentUrlWithUtmDefaults() {
  if (typeof window === "undefined") return "";
  const u = new URL(window.location.href);
  const q = u.searchParams;

  if (urlSinUtmsPrincipales(q)) {
    q.set("utm_source", UTM_DEFAULT_SOURCE);
    q.set("utm_medium", UTM_DEFAULT_MEDIUM);
    q.set("utm_campaign", UTM_DEFAULT_CAMPAIGN);
    q.delete("utm_term");
    return u.toString();
  }

  const urlSource = q.get("utm_source")?.trim();
  if (urlSource) {
    q.set("utm_source", resolveUtmSource(urlSource));
  } else {
    q.set("utm_source", resolveUtmSource(storageGet("utm_source")));
  }
  if (!q.get("utm_medium")?.trim()) {
    q.set("utm_medium", storageGet("utm_medium")?.trim() || UTM_DEFAULT_MEDIUM);
  }
  if (!q.get("utm_campaign")?.trim()) {
    q.set("utm_campaign", storageGet("utm_campaign")?.trim() || UTM_DEFAULT_CAMPAIGN);
  }

  return u.toString();
}

export function buildUtmQueryString() {
  const { utm_source, utm_medium, utm_campaign, utm_term } = getUtmParams();
  const parts = [
    `utm_source=${encodeURIComponent(utm_source)}`,
    `utm_medium=${encodeURIComponent(utm_medium)}`,
    `utm_campaign=${encodeURIComponent(utm_campaign)}`,
  ];
  if (utm_term) parts.push(`utm_term=${encodeURIComponent(utm_term)}`);
  return `?${parts.join("&")}`;
}
